
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import { ApiClient } from "@/utilities/ApiClient";
    import { ButtonToggler } from "@/utilities/ButtonToggler";
    import { required, email } from "vuelidate/lib/validators";
    import { Utils } from "@/utilities/Utils";
    import { Validations } from "vuelidate-property-decorators";
    import { VoucherCodeSaveRequest } from "@/model/Api/VoucherCodeSaveRequest";
    import { Prop } from "vue-property-decorator";
    import { BookingVM } from "@/model/Api/VM/BookingVM";


    @Component({
        components: { 
            ApiButton
        }
    })
    export default class FoodVoucherModal extends Vue {

        //
        // -- properties
        //

        @Prop({}) private booking !: BookingVM;

        private allocationID: number = 0;
        private voucherCodeAmount = 0;
        private voucherCode = "";
        private voucherCodeTotal = 0;
        private isNew = false;
        private saveRequest = new VoucherCodeSaveRequest();

        private get dialogueTitle(): string {
            return "Food Voucher";
        }

        //
        // -- methods
        //

        addNew(allocationID: number) {
            this.isNew = true;
            this.allocationID = allocationID;
            this.voucherCodeAmount = 0;
            this.$bvModal.show("foodVoucherModal");
        }

        async edit(allocationID: number, voucherCodeAmount: number, voucherCode: string, voucherCodeTotal: number) {
            this.isNew = false;
            this.allocationID = allocationID;
            this.voucherCodeAmount = voucherCodeAmount;
            this.voucherCode = voucherCode;
            this.voucherCodeTotal = voucherCodeTotal;
            this.$bvModal.show("foodVoucherModal");
        }

        cancel() {
            this.$bvModal.hide(`foodVoucherModal`);
        }

        async save(event: any) {
            this.saveRequest.allocationID = this.allocationID;
            this.saveRequest.voucherCodeAmount = this.voucherCodeAmount;
            await ApiClient.post("/Api/Booking/VoucherCodeUpdate", this.saveRequest, event);
            toastr.success("Saved");
            this.$emit("loadEmployees")
            this.$bvModal.hide(`foodVoucherModal`);
        }

        async deleteCode(event: any) {
            this.saveRequest.allocationID = this.allocationID;
            this.saveRequest.voucherCodeAmount = 0;
            await ApiClient.post("/Api/Booking/VoucherCodeDelete", this.saveRequest, event);
            toastr.success("Voucher Code Removed");
            this.$emit("loadEmployees")
            this.$bvModal.hide(`foodVoucherModal`);
        }
        

        @Validations()
        validations() {
            const validations = {
                email: {} as any
            };
            validations.email = { required, email };
            return validations; 
        }

        // from https://github.com/vuelidate/vuelidate/issues/179
        private async isValid(): Promise<boolean> {
            this.$v.$reset();
            this.$v.$touch();
            await this.waitForValidation();
            return Promise.resolve(!this.$v.$error);
        }

        // from https://github.com/vuelidate/vuelidate/issues/179
        private waitForValidation() {
            return new Promise<void>(resolve => {
                if (this.$v.$error || !this.$v.$pending) {
                    return resolve();
                }
                const poll = setInterval(() => {
                    if (!this.$v.$pending) {
                        clearInterval(poll)
                        resolve()
                    }
                }, 200);
            })
        }
    }

